// Shared
import { useAuth } from '@/common/appContext';

export interface BasicQueryParams {
  companyID: number;
  employeeID: number;
  token: string;
  correlationId: string;
  basicEnabled: boolean;
}

export function useBasicQueryParams(): BasicQueryParams {
  const { companyID, correlationId, employeeID, token } = useAuth();

  return {
    companyID: companyID as number,
    correlationId,
    employeeID: employeeID as number,
    token,
    basicEnabled: Boolean(companyID && employeeID && token),
  };
}
